module.exports = __webpack_public_path__ + "assets/img/brother.e031f451.png";